module.exports = __webpack_public_path__ + "static/media/home-banner.299ab255.png";